import { Component, OnInit, OnDestroy, HostListener, HostBinding, ElementRef, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';

import { Subscription } from 'rxjs';
import { KeyboardService } from '../keyboard.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'teclado-numerico',
  template: `
 <div *ngIf="tipoTeclado['numerico']" class="p-1" style="height:100%">
      <div fxLayout="row nowrap" class="" fxLayoutGap="10px" style="height: 25%">
        <button fxFlex="33,33" (click)="numeroSelecionado(7)" class="app-teclas">7</button>
        <button fxFlex="33,33" (click)="numeroSelecionado(8)"  class="app-teclas">8</button>
        <button fxFlex="33,33" (click)="numeroSelecionado(9)"  class="app-teclas">9</button>
      </div>
      <div fxLayout="row nowrap" class="" fxLayoutGap="10px" style="height: 25%;">
        <button fxFlex="33,33" (click)="numeroSelecionado(4)"  class="app-teclas">4</button>
        <button fxFlex="33,33" (click)="numeroSelecionado(5)"  class="app-teclas">5</button>
        <button fxFlex="33,33" (click)="numeroSelecionado(6)"  class="app-teclas">6</button>
      </div>
      <div fxLayout="row nowrap" class="" fxLayoutGap="10px" style="height: 25%;">
        <button fxFlex="33,33" (click)="numeroSelecionado(1)"  class="app-teclas" class="app-teclas">1</button>
        <button fxFlex="33,33" (click)="numeroSelecionado(2)"  class="app-teclas" class="app-teclas">2</button>
        <button fxFlex="33,33" (click)="numeroSelecionado(3)"  class="app-teclas" class="app-teclas">3</button>
      </div>
      <div fxLayout="row nowrap" class="" fxLayoutGap="10px" style="height: 25%;">
        <button fxFlex="33,33" (click)="numeroSelecionado(0)"  class="app-teclas">0</button>
        <button fxFlex="33,33" (click)="onClear()" class="text-center app-teclas">C</button>
        <button fxFlex="33,33" (click)="onBackspace()" class="text-center app-teclas">
          <mat-icon style="font-size: xxx-large;">keyboard_backspace</mat-icon>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./teclado-numerico.view.css']
})
export class TecladoNumericoView implements OnInit, OnDestroy, AfterViewInit {
  @HostBinding('class.shown')
  private shown: boolean;
  @Output() aoPressTecla = new EventEmitter();
  @Output() aoPressBackspace = new EventEmitter();
  @Output() aoLimprar = new EventEmitter();
  @Input() tecladoLivre = false;
  @Input() tipoTeclado: any  = {
    numerico: false,
    alpha: true
  };
  private keyboardSubscription: Subscription;

  constructor(private el: ElementRef,  public keyboard: KeyboardService) {
  }

  ngOnInit() {
    this.keyboardSubscription = this.keyboard.keyboardRequested.subscribe(show => {
      if (show) {
        this.shown = true;
      } else {
        this.shown = true;
      }
    });
  }

  numeroSelecionado(valor:number){
    this.aoPressTecla.emit(valor);
  }
  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.keyboardSubscription.unsubscribe();
  }

  onShift() {
    this.keyboard.shift = !this.keyboard.shift;
  }

  onBackspace() {
    this.aoPressBackspace.emit(true);
  }

  onClear(){
    this.aoLimprar.emit(true);
  }

  @HostListener('mousedown', ['$event'])
  @HostListener('click', ['$event'])
  onMouseEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
